import React from 'react'
import { format } from 'date-fns'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import LgyField from 'app/components/util/lgy-field/LgyField'

const RequesterDetailsSection = ({ assignmentDetails }) =>
  <LgySubsection header='Requester Details' className='requester-details-section'>
    <LgyField className='non-input' label='Name' value={assignmentDetails.requesterName} />
    <LgyField className='non-input' label='ID' value={assignmentDetails.requesterId} />
    <LgyField className='non-input' label='Request received date' value={format(assignmentDetails.createdDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })} />
  </LgySubsection>

export default RequesterDetailsSection